module.exports = __webpack_public_path__ + "img/igv-mobile-screenshot-portrait.820d577a.png";